export const blockIconsTextformattingFormatQuoteNew = (
	<span className='material-symbols-outlined'>format_quote</span>
);
